<ng-content></ng-content>
@if (
  containerDataValues().showBackBtn || containerDataValues().showForwardBtn
) {
  <hr class="divider" />
  <div class="btn-container">
    @if (containerDataValues().showForwardBtn) {
      <button
        type="submit"
        boelsButton
        action="next"
        [icon]="faPaperPlane"
        variant="main"
        (click)="forwardBtnClicked.emit()"
      >
        {{ containerDataValues().forwardBtnText | transloco }}
      </button>
    }
    @if (containerDataValues().showBackBtn) {
      <button
        boelsButton
        variant="secondary"
        action="none"
        [icon]="faChevronLeft"
        (click)="backBtnClicked.emit()"
      >
        {{ containerDataValues().backBtnText | transloco }}
      </button>
    }
  </div>
}
